import { Component, type ErrorInfo, type ReactNode } from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<
  { children: ReactNode },
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Master Notes rendering error", error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <main className="grid min-h-screen place-items-center bg-slate-50 p-6">
        <div className="max-w-md rounded-3xl border border-slate-200 bg-white p-8 text-center shadow-xl shadow-slate-200/50">
          <AlertTriangle className="mx-auto mb-4 size-10 text-amber-500" />
          <h1 className="text-2xl font-bold text-slate-950">
            This page hit an unexpected problem
          </h1>
          <p className="mt-3 text-sm leading-6 text-slate-600">
            Your work is still safe. Refresh the page to try again.
          </p>
          <Button className="mt-6" onClick={() => window.location.reload()}>
            Refresh page
          </Button>
        </div>
      </main>
    );
  }
}
